import envStore from '@shared/env'
import React from 'react'
import DraggerBox from '.'
import Store from 'store'
import { InboxOutlined } from '@ant-design/icons'
import { isEmpty, path, pathOr, T } from 'ramda'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

interface ImageDraggerBoxProps {
  /**
   * 成功後會在 Dragger Box 的上傳 icon 處，顯示預覽圖
   */
  disabled?: boolean
  showPreviewInDraggerBox?: boolean
  defaultPreviewUrl?: string
  showUploadList?: boolean
  value?: string | { hash: string; url: string; path: string }
  onChange?: (imageInfo?: { hash: string; url: string; path: string }) => void
  action?: string
  accept?: string
}

export default React.forwardRef<any, ImageDraggerBoxProps>((props, ref) => {
  const { t } = useTranslation()

  const {
    value,
    onChange,
    showPreviewInDraggerBox = false,
    defaultPreviewUrl,
    showUploadList = true,
    disabled = false,
    action,
    accept = '.png,.svg',
    ...others
  } = props

  const [previewUrl, setPreviewUrl] = React.useState(defaultPreviewUrl)

  React.useEffect(() => {
    setPreviewUrl(defaultPreviewUrl)
  }, [defaultPreviewUrl])

  return (
    <DraggerBox
      accept={accept}
      ref={ref}
      disabled={disabled}
      showUploadList={showUploadList}
      multiple={false}
      onPreview={file => {
        const image_window = window.open('', '_blank')
        image_window?.document.write(`
          <html>
            <head>
            </head>
            <body>
              <img src="${pathOr(
                '',
                ['response', 'data', 'url'],
                file
              )}" alt="img" height="100%" width="100%">
            </body>
          </html>
        `)
      }}
      action={`${envStore.apiBaseUrl}${action}`}
      headers={{
        Authorization: `Bearer ${Store.get('sctc_token')}`,
        'X-Requested-With': null as any,
      }}
      listType="picture"
      maxCount={1}
      onChange={({ fileList }) => {
        if (fileList.length === 0) {
          onChange && onChange(undefined)
        } else if (path([0, 'status'], fileList) === 'done') {
          onChange &&
            onChange(pathOr(undefined, [0, 'response', 'data'], fileList))

          setPreviewUrl(pathOr('', [0, 'response', 'data', 'url'], fileList))
        } else if (path([0, 'status'], fileList) === 'error') {
          message.error(`${pathOr('', [0, 'name'], fileList)}${t('systen:upload failed')}`)
        }
      }}
      {...others}>
      {showPreviewInDraggerBox && !isEmpty(previewUrl) ? (
        <div>
          <img
            className="mx-auto"
            src={previewUrl}
            alt="preview"
            style={{ maxHeight: '50px', maxWidth: '50px' }}
          />
        </div>
      ) : (
        <p
          style={{
            color: '#4A4A4A',
            fontSize: '50px',
          }}>
          <InboxOutlined />
        </p>
      )}
      <p className="ant-upload-text text-primary">{t('systen:drag here')}</p>
      <p className="ant-upload-hint">{t('system:support .png .svg')}</p>
    </DraggerBox>
  )
})
